export default {
  name: 'VideoBlockCmp',
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      videoCache: Object.create(null),
    }
  },
  computed: {
    normalizedItem() {
      return {
        ...this.item,
        videoData: this.getVideoData(this.item.video),
      }
    },
  },
  methods: {
    getVideoData(rawValue) {
      if (!rawValue || typeof rawValue !== 'string') {
        return null
      }

      const cacheKey = rawValue.trim()

      if (!cacheKey) {
        return null
      }

      if (Object.prototype.hasOwnProperty.call(this.videoCache, cacheKey)) {
        return this.videoCache[cacheKey]
      }

      const normalizedVideo = this.normalizeVideo(cacheKey)

      this.$set(this.videoCache, cacheKey, normalizedVideo)

      return normalizedVideo
    },
    normalizeVideo(rawValue) {
      const value = rawValue.trim()

      if (!value) {
        return null
      }

      if (this.isIframeString(value)) {
        return this.parseIframeString(value)
      }

      if (this.isUrlString(value)) {
        return this.parseUrl(value)
      }

      return null
    },
    isIframeString(value) {
      return /<iframe/i.test(value)
    },
    isUrlString(value) {
      try {
        new URL(value)
        return true
      } catch (error) {
        return false
      }
    },
    parseIframeString(iframeString) {
      try {
        const parser = new DOMParser()
        const doc = parser.parseFromString(iframeString, 'text/html')
        const iframe = doc.querySelector('iframe')

        if (!iframe) {
          return null
        }

        const src = iframe.getAttribute('src')

        if (!src || !this.isAllowedIframeUrl(src)) {
          return null
        }

        return {
          type: 'iframe',
          src,
        }
      } catch (error) {
        console.error('Failed to parse iframe video:', error)
        return null
      }
    },
    parseUrl(url) {
      try {
        const parsedUrl = new URL(url)

        const vkVideoData = this.parseVkVideoUrl(parsedUrl)
        if (vkVideoData) {
          return vkVideoData
        }

        const rutubeVideoData = this.parseRutubeUrl(parsedUrl)
        if (rutubeVideoData) {
          return rutubeVideoData
        }

        const nxCloudVideoData = this.parseNxCloudUrl(parsedUrl)
        if (nxCloudVideoData) {
          return nxCloudVideoData
        }

        return null
      } catch (error) {
        console.error('Failed to parse video url:', error)
        return null
      }
    },
    parseVkVideoUrl(url) {
      const isVkVideoHost = url.origin.includes('vkvideo')
      const match = url.pathname.match(/video-(\d+)_(\d+)/)

      if (!isVkVideoHost || !match) {
        return null
      }

      const [_, ownerId, videoId] = match

      return {
        type: 'iframe',
        src: `${url.origin}/video_ext.php?oid=-${ownerId}&id=${videoId}&hd=1`,
      }
    },
    parseRutubeUrl(url) {
      const isRutubeHost = url.origin.includes('rutube')

      if (!isRutubeHost) {
        return null
      }

      return {
        type: 'iframe',
        src: `${url.origin}/play/embed${url.pathname}`,
      }
    },
    parseNxCloudUrl(url) {
      const isNxCloudHost = url.origin.includes('nxcloud.axoftglobal')

      if (!isNxCloudHost) {
        return null
      }

      return {
        type: 'video',
        src: `${url.toString()}/download`,
      }
    },
    isAllowedIframeUrl(url) {
      try {
        return new URL(url).hostname
      } catch (error) {
        return false
      }
    },
  },
}



// WEBPACK FOOTER //
// ./src/templates/components/ui-components/video-block/component.js